/** Canonical product name for UI copy, analytics, errors, and logs. */
export const ONBOARDING_AGENT_DISPLAY_NAME = "Onboarding Agent";

export const ONBOARDING_AGENT_LOG_PREFIX = `[${ONBOARDING_AGENT_DISPLAY_NAME}]`;

export const ABSOLUTE_HTTP_HREF_PATTERN = /^https?:\/\//i;

export const MARKDOWN_TOKEN_PATTERN = /(\[[^\]]+\]\([^)]+\)|\*\*[^*]+\*\*)/g;
export const MARKDOWN_LINK_PATTERN = /^\[([^\]]+)\]\(([^)]+)\)$/;
export const MARKDOWN_STRONG_PATTERN = /^\*\*([^*]+)\*\*$/;

export const ASSISTANT_PARAGRAPH_SEPARATOR_PATTERN = /\n{2,}/;
export const ASSISTANT_LINE_SEPARATOR = "\n";
export const CONVERSATION_MESSAGE_SEPARATOR = "\n\n";

export const ONBOARDING_AGENT_QUOTA_EXCEEDED_STATUS = 403;
export const ONBOARDING_AGENT_QUOTA_EXCEEDED_MARKER = "Quota exceeded";

export const REACT_ID_SEPARATOR_PATTERN = /:/g;
export const ESCAPED_TRANSLATION_NEWLINE_PATTERN = /\\n/g;

export const ONBOARDING_AGENT_STREAM_CHARS_PER_SECOND = 120;

export const ONBOARDING_AGENT_SECONDARY_REVEAL_INTERVAL_MS = 100;

export const ONBOARDING_AGENT_SECONDARY_ITEM_ANIMATION_MS = 200;

export const ONBOARDING_AGENT_HAS_OPENED_PREFERENCE_KEY = "onboardingAgentHasOpened";

export const SOLE_WEBSITE_URL_PATTERN =
    /^(?:https?:\/\/)?([a-z0-9](?:[a-z0-9-]*[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)+)(?::\d+)?(?:\/[^\s]*)?$/i;

export const DIRECT_LINK_DISPLAY_ADDRESS_MAX_LENGTH = 25;
export const DIRECT_LINK_DISPLAY_ADDRESS_ELLIPSIS = "...";

export const WEBSITE_PERFORMANCE_UI_ROUTER_STATE = "digitalsuite_website_websiteperformance";
export const WEBSITE_CONTENT_UI_ROUTER_STATE = "digitalsuite_website_content";
export const WEBSITE_CONTENT_SELECTED_TAB_FOLDERS = "Folders";
